import { isValidIBAN } from 'ibantools';

import { AbstractControl, ValidationErrors } from '@angular/forms';

export function ibanValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  const ibanNumber = control.value as string;
  const validIBAN = isValidIBAN(ibanNumber);
  return validIBAN ? null : { iban: true };
}
